<template>
  <div @click.stop="closeTreeEdit">
    <div class="xc-page">
      <div class="xc-page-main">
        <!-- 面包屑 -->
        <div class="xc-breadcrumb">
          <a href>终端管理</a>
          <a>终端列表</a>
        </div>

        <!-- 铺满 -->
        <div class="xc-row xc-s-flex content-wrap" ref="devicePage">
          <div class="device-group xc-card">
            <div class="xc-card-header">
              <div class="xc-card-title">
                终端组
                <span>点击右键操作更多</span>
              </div>
            </div>
            <!-- 树形目录 -->
            <div class="device-tree-wrap" @scroll="closeTreeEdit">
              <div class="tree" v-if="treeList.length">
                <xc-tree
                  :data.sync="treeList"
                  @selected="selectFunc"
                  @rightClick="rightClick"
                  label="name"
                  linked
                  :expand="0"
                  ref="groupTree"
                ></xc-tree>
                <div
                  ref="treeEdit"
                  class="xc-tree-edit"
                  v-show="showTreeEdit || showTreeSon || showTreeBrother"
                  @click.stop
                >
                  <ul>
                    <li @click="openEditGroup('add')" v-show="showTreeBrother">
                      添加分组
                    </li>
                    <li @click="openEditGroup('addChild')" v-show="showTreeSon">
                      添加子分组
                    </li>
                    <li @click="openEditGroup('edit')" v-show="showTreeEdit">
                      编辑分组
                    </li>
                    <li @click="openEditGroup('delete')" v-show="showTreeEdit">
                      删除分组
                    </li>
                    <li @click="openEditGroup('move')" v-show="showTreeEdit">
                      移动分组
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div
            class="xc-s-flex xc-card"
            style="overflow-x: hidden; display: flex; flex-direction: column"
          >
            <div class="xc-row" style="margin-bottom: 0">
              <div class="xc-card">
                <div class="xc-card-content">
                  <form class="xc-form">
                    <div
                      class="xc-form-inline"
                      style="flex-wrap: wrap; margin-bottom: 0px"
                    >
                      <li class="xc-form-item search-wrap add-bottom">
                        <select
                          class="xc-select change-wrap"
                          v-model="changeItem"
                        >
                          <option value="MAC地址">MAC地址</option>
                          <option value="终端名">终端名</option>
                          <option value="IP">IP</option>
                        </select>
                        <input
                          type="text"
                          class="xc-input"
                          placeholder="请输入"
                          v-model="searchInfo"
                        />
                      </li>
                      <!-- <xc-form-item label="MAC地址：">
                      <input 
                        type="text" 
                        class="xc-input" 
                        placeholder="请输入MAC地址" 
                        v-model="mix_query.deviceMac"
                      >
                    </xc-form-item>
                    <xc-form-item label="终端名：" labelWidth="0">
                      <input 
                        type="text" 
                        class="xc-input" 
                        placeholder="请输入" 
                        v-model="mix_query.deviceName"
                      >
                    </xc-form-item>
                    <xc-form-item label="IP：" labelWidth="0">
                      <input 
                        type="text" 
                        class="xc-input" 
                        placeholder="请输入" 
                        v-model="mix_query.ip"
                      >
                    </xc-form-item> 
                     <xc-form-item label="终端类型：" class="add-bottom">
                        <select
                          class="xc-select"
                          v-model="mix_query.deviceStatus"
                        >
                          <option value selected>全部</option>
                          <option value="0">在线</option>
                          <option value="1">离线</option>
                        </select>
                      </xc-form-item>-->
                      <xc-form-item label="终端状态：" class="add-bottom">
                        <select
                          class="xc-select"
                          v-model="mix_query.deviceStatus"
                        >
                          <option value selected>全部</option>
                          <option value="0">在线</option>
                          <option value="1">离线</option>
                        </select>
                      </xc-form-item>
                      <!-- <xc-form-item label="门店名称：" class="add-bottom">
                      <input 
                        type="text" 
                        class="xc-input" 
                        placeholder="请输入门店名称" 
                        v-model="mix_query.storeName"
                      >
                    </xc-form-item> -->
                      <xc-form-item label="播放状态：" class="add-bottom">
                        <select
                          class="xc-select"
                          v-model="mix_query.programDue"
                        >
                          <option value selected>全部</option>
                          <option value="false">有刊</option>
                          <option value="true">空刊</option>
                        </select>
                      </xc-form-item>
                      <div class="xc-btn-group add-bottom">
                        <button
                          type="submit"
                          class="xc-btn xc-btn-primary"
                          @click.prevent="searchList"
                        >
                          查询
                        </button>
                        <button
                          type="button"
                          class="xc-btn xc-btn-default"
                          @click="exportStore"
                        >
                          导出
                        </button>
                        <button
                          type="button"
                          class="xc-btn xc-btn-default"
                          @click.prevent="exportShangkan"
                        >
                          导出上刊
                        </button>
                      </div>
                    </div>
                    <div class="xc-form-inline new-style">
                      <div class="device-info">
                        <div class="device-info-item">
                          <div class="item">
                            总计：<span>{{ deviceInfo.total }}</span>
                          </div>
                        </div>
                        <div class="device-info-item">
                          <div class="item">
                            在线：<span>{{ deviceInfo.totalOnline }}</span>
                          </div>
                        </div>
                        <div class="device-info-item">
                          <div class="item">
                            离线：<span>{{ deviceInfo.totalOffline }}</span>
                          </div>
                        </div>
                      </div>

                      <!-- 表格数据操作 -->
                      <div
                        class="xc-btn-group xc-btn-group-resete"
                        v-if="userModule"
                      >
                        <a
                          v-if="userModule.button['/ckips/devicegroup/move']"
                          class="xc-btn xc-btn-default"
                          @click="openMode('moveGroup')"
                          >移动分组</a
                        >
                        <a
                          v-if="userModule.button['/ckips/device/shutdown']"
                          class="xc-btn xc-btn-default"
                          @click="openMode('remoteShutdown')"
                          >远程关机</a
                        >
                        <a
                          v-if="userModule.button['/ckips/device/restart']"
                          class="xc-btn xc-btn-default"
                          @click="openMode('restartDevice')"
                          >重启终端</a
                        >
                        <a
                          v-if="userModule.button['/ckips/device/setVolume']"
                          class="xc-btn xc-btn-default"
                          @click="openMode('volumeSetting')"
                          >音量设置</a
                        >
                        <a
                          v-if="userModule.button['/ckips/device/untie']"
                          class="xc-btn xc-btn-default"
                          @click="openMode('unbundlingDevice')"
                          >解绑终端</a
                        >
                        <a
                          v-if="
                            userModule.button[
                              '/ckips/device/setTimerShutDownOrStart'
                            ]
                          "
                          class="xc-btn xc-btn-default"
                          @click="openMode('switchgear')"
                          >定时开关机</a
                        >
                        <a class="xc-btn xc-btn-default" @click="publishProgram"
                          >发布节目</a
                        >
                        <a class="xc-btn xc-btn-default" @click="increasedPlay"
                          >文件增播</a
                        >
                        <a class="xc-btn xc-btn-default" @click="reducePlay"
                          >文件减播</a
                        >
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <!--  带滚动条表格 -->
            <div class="table-content xc-s-flex" style="overflow-x: auto">
              <div class="padding-bottom">
                <!-- 带滚动条的表格 -->
                <table class="xc-table">
                  <thead>
                    <th>
                      <input
                        type="checkbox"
                        class="xc-checkbox"
                        v-model="mix_isSelectAll"
                      />
                    </th>
                    <th>终端组</th>
                    <th>终端名</th>
                    <th>门店名</th>
                    <!-- <th>所属房间</th>
                    <th>终端类型</th> -->
                    <th>在线状态</th>
                    <th>播放状态</th>
                    <th>设备类型/尺寸</th>
                    <!-- <th>设备尺寸</th> -->
                    <th>分辨率</th>
                    <!-- <th>机型</th> -->
                    <!-- <th>导入门店</th> -->
                    <!-- <th>终端任务</th> -->
                    <!-- <th>固件版本</th> -->
                    <!-- <th>设备IP</th> -->
                    <th>设备MAC</th>
                    <th>Mips版本</th>
                    <th>播放列表</th>
                    <th>操作</th>
                  </thead>
                  <tbody>
                    <template v-if="list && list.length">
                      <tr v-for="(item, key) in list" :key="key">
                        <td>
                          <input
                            type="checkbox"
                            class="xc-checkbox"
                            v-model="item.mix_checkbox"
                            @click="mix_selectListItem(item)"
                          />
                        </td>
                        <td>
                          {{ item.groupName }}
                        </td>
                        <td>
                          {{ item.deviceName }}
                        </td>
                        <td>
                          {{ item.storeName }}
                        </td>
                        <td>
                          {{ item.deviceStatus }}
                        </td>
                        <td>
                          {{ item.programDue | getPlayDue }}
                        </td>
                        <td>{{ item.deviceType }}/{{ item.screenSize }}</td>
                        <!-- <td>
                        {{item.screenSize}}
                      </td> -->
                        <td>
                          {{ item.resolvingPower }}
                        </td>
                        <!-- <td>
                        {{item.model}}
                      </td>
                      <td>
                        {{item.storeName}}
                      </td>
                      <td>
                        (+{{item.addProgramsCount}},-{{item.reduceProgramsCount}})
                      </td> -->
                        <!-- <td>
                        {{item.firmwareVersion}}
                      </td> -->
                        <!-- <td>
                        {{item.lastReportIp}}
                      </td> -->
                        <td>
                          {{ item.deviceMac }}
                        </td>
                        <td>
                          {{ item.softwareVersion }}
                        </td>
                        <td class="xc-link">
                          <a @click="action('goListDetail', item, $event)"
                            >查看</a
                          >
                        </td>
                        <td>
                          <div class="xc-link">
                            <a @click="action('getDeviceDetail', item, $event)"
                              >详情</a
                            >
                          </div>
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td colspan="14" class="xc-s-tac">暂无数据</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗 -->
    <!-- 定时开关机 -->
    <div class="xc-modal xc-modal-dialog" v-if="modalName == 'switchgear'">
      <div class="xc-modal-mask" @click="modalName = null"></div>
      <div class="xc-modal-wrap xc-anim-scaleIn">
        <div class="xc-modal-content">
          <div class="xc-modal-header">
            <div class="xc-modal-title">定时开关机设置</div>
            <div class="xc-modal-close" @click="modalName = null"></div>
          </div>
          <div class="xc-modal-body xc-padding-left">
            <div class="xc-form-inline">
              <xc-form-item label="设备名称">
                <input
                  type="text"
                  maxlength="255"
                  class="xc-input xc-input-disabled"
                  disabled
                  placeholder="请输入终端名称"
                  v-model="deviceNameList"
                />
              </xc-form-item>
              <xc-form-item label="终端序列号">
                <input
                  type="text"
                  maxlength="255"
                  class="xc-input xc-input-disabled"
                  disabled
                  placeholder="请输入"
                  v-model="deviceSerial.deviceSerialNumList"
                />
              </xc-form-item>
            </div>
            <div class="xc-form-inline">
              <xc-form-item label="是否定时开关机">
                <xc-radio
                  :radio-value="radioValue"
                  @radio-fun="radioSelectFun"
                />
              </xc-form-item>
            </div>
            <div class="set-time" v-if="showDate">
              <div class="xc-form-title" v-if="limitCheck">工作日:</div>
              <div class="xc-form-inline">
                <xc-form-item label="开机时间" class="xc-form-item-fixed">
                  <flat-pickr
                    v-model="bootTime"
                    class="xc-input"
                    :config="config"
                    placeholder="请选择时间"
                  ></flat-pickr>
                </xc-form-item>
                <xc-form-item label="关机时间" class="xc-form-item-fixed">
                  <flat-pickr
                    v-model="offTime"
                    class="xc-input"
                    :config="config"
                    placeholder="请选择时间"
                  ></flat-pickr>
                </xc-form-item>
              </div>
              <div class="xc-form-title" v-if="limitCheck">周末:</div>
              <div class="xc-form-inline" v-if="limitCheck">
                <xc-form-item label="开机时间" class="xc-form-item-fixed">
                  <flat-pickr
                    v-model="nonWorkDayBootTime"
                    class="xc-input"
                    :config="config"
                    placeholder="请选择时间"
                  ></flat-pickr>
                </xc-form-item>
                <xc-form-item label="关机时间" class="xc-form-item-fixed">
                  <flat-pickr
                    v-model="nonWorkDayOffTime"
                    class="xc-input"
                    :config="config"
                    placeholder="请选择时间"
                  ></flat-pickr>
                </xc-form-item>
              </div>
            </div>
          </div>
          <div class="xc-modal-footer xc-flex-center">
            <div class="xc-btn-group">
              <div class="xc-btn xc-btn-default" @click="modalName = null">
                取消
              </div>
              <div
                class="xc-btn xc-btn-primary"
                @click="mix_batchAction('switchgear', $event)"
              >
                确定
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 终端移动分组 -->
    <div class="xc-modal xc-modal-dialog" v-if="modalName == 'moveGroup'">
      <div class="xc-modal-mask" @click="modalName = null"></div>
      <div class="xc-modal-wrap xc-anim-scaleIn">
        <div class="xc-modal-content">
          <div class="xc-modal-header">
            <div class="xc-modal-title">移动分组</div>
            <div class="xc-modal-close" @click="modalName = null"></div>
          </div>
          <div class="xc-modal-body">
            <xc-tree
              :data.sync="deviceGroupList"
              @nodeClick="selectGroupName"
              label="name"
              linked
              :expand="0"
            ></xc-tree>
          </div>
          <div class="xc-modal-footer xc-flex-center">
            <div class="xc-btn-group">
              <div class="xc-btn xc-btn-default" @click="modalName = null">
                取消
              </div>
              <div
                class="xc-btn xc-btn-primary"
                @click="mix_batchAction('moveGroup', $event)"
              >
                确定
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 音量设置 -->
    <div class="xc-modal xc-modal-dialog" v-if="modalName == 'volumeSetting'">
      <div class="xc-modal-mask" @click="modalName = null"></div>
      <div class="xc-modal-wrap xc-anim-scaleIn">
        <div class="xc-modal-content">
          <div class="xc-modal-header">
            <div class="xc-modal-title">远程音量设置</div>
            <div class="xc-modal-close" @click="modalName = null"></div>
          </div>
          <div class="xc-modal-body xc-flex-center">
            <form
              class="xc-form"
              name="voice"
              style="min-width: 450px"
              @submit.prevent="veeFormSubmit"
              data-vv-scope="voice"
            >
              <xc-form-item
                label="音量值"
                required
                :error="errors.first('voiceValue', 'voice')"
              >
                <input
                  v-validate="'required'"
                  data-vv-as="音量值"
                  name="voiceValue"
                  type="text"
                  maxlength="255"
                  class="xc-input"
                  placeholder="建议音量40"
                />
              </xc-form-item>
            </form>
          </div>
          <div class="xc-modal-footer xc-flex-center">
            <div class="xc-btn-group">
              <div class="xc-btn xc-btn-default" @click="modalName = null">
                取消
              </div>
              <div
                class="xc-btn xc-btn-primary"
                @click="mix_batchAction('volumeSetting', $event)"
              >
                确定
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 远程重启 -->
    <div class="xc-modal xc-modal-dialog" v-if="modalName == 'restartDevice'">
      <div class="xc-modal-mask" @click="modalName = null"></div>
      <div class="xc-modal-wrap xc-anim-scaleIn">
        <div class="xc-modal-content">
          <div class="xc-modal-header">
            <div class="xc-modal-title">重启终端</div>
            <div class="xc-modal-close" @click="modalName = null"></div>
          </div>
          <div class="xc-modal-body xc-flex-center">
            <div class="xc-device-tipText">
              "共{{ deviceSerial.deviceSerialNumLen }}个，终端序列号为：{{
                deviceSerial.deviceSerialNumList
              }}"
            </div>
          </div>
          <div class="xc-modal-footer xc-flex-center">
            <div class="xc-btn-group">
              <div class="xc-btn xc-btn-default" @click="modalName = null">
                取消
              </div>
              <div
                class="xc-btn xc-btn-primary"
                @click="mix_batchAction('restartDevice', $event)"
              >
                确定
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 远程关机 -->
    <div class="xc-modal xc-modal-dialog" v-if="modalName == 'remoteShutdown'">
      <div class="xc-modal-mask" @click="modalName = null"></div>
      <div class="xc-modal-wrap xc-anim-scaleIn">
        <div class="xc-modal-content">
          <div class="xc-modal-header">
            <div class="xc-modal-title">远程关机</div>
            <div class="xc-modal-close" @click="modalName = null"></div>
          </div>
          <div class="xc-modal-body xc-flex-center">
            <div class="xc-device-tipText">
              "共{{ deviceSerial.deviceSerialNumLen }}个，终端序列号为：{{
                deviceSerial.deviceSerialNumList
              }}"
            </div>
          </div>
          <div class="xc-modal-footer xc-flex-center">
            <div class="xc-btn-group">
              <div class="xc-btn xc-btn-default" @click="modalName = null">
                取消
              </div>
              <div
                class="xc-btn xc-btn-primary"
                @click="mix_batchAction('remoteShutdown', $event)"
              >
                确定
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 解绑终端 -->
    <div
      class="xc-modal xc-modal-dialog"
      v-if="modalName == 'unbundlingDevice'"
    >
      <div class="xc-modal-mask" @click="modalName = null"></div>
      <div class="xc-modal-wrap xc-anim-scaleIn">
        <div class="xc-modal-content">
          <div class="xc-modal-header">
            <div class="xc-modal-title">远程解绑终端</div>
            <div class="xc-modal-close" @click="modalName = null"></div>
          </div>
          <div class="xc-modal-body xc-flex-center">
            <div class="xc-device-tipText">
              "共{{ deviceSerial.deviceSerialNumLen }}个，终端序列号为：{{
                deviceSerial.deviceSerialNumList
              }}"
            </div>
          </div>
          <div class="xc-modal-footer xc-flex-center">
            <div class="xc-btn-group">
              <div class="xc-btn xc-btn-default" @click="modalName = null">
                取消
              </div>
              <div
                class="xc-btn xc-btn-primary"
                @click="mix_batchAction('unbundlingDevice', $event)"
              >
                确定
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 编辑终端分组 -->
    <div class="xc-modal xc-modal-dialog" v-if="modalName == 'edit-group'">
      <div class="xc-modal-mask" @click="modalName = null"></div>
      <div class="xc-modal-wrap xc-anim-scaleIn">
        <div class="xc-modal-content">
          <div class="xc-modal-header">
            <div class="xc-modal-title">
              {{ editGroupTitll }}
            </div>
            <div class="xc-modal-close" @click="modalName = null"></div>
          </div>
          <div class="xc-modal-body xc-flex-center">
            <div class="xc-device-tipText" v-if="deleteGroup">
              确定删除"{{ deviceGroupName }}"？
            </div>
            <form
              class="xc-form"
              name="treeAddGroup"
              style="min-width: 450px"
              @submit.prevent="veeFormSubmit"
              data-vv-scope="form"
              v-if="!deleteGroup"
            >
              <xc-form-item
                label="组名"
                required
                :error="errors.first('name', 'form')"
              >
                <input
                  v-validate="'required'"
                  data-vv-as="组名"
                  name="name"
                  type="text"
                  maxlength="30"
                  class="xc-input"
                  placeholder="请输入"
                  v-model="deviceGroupName"
                />
              </xc-form-item>
            </form>
          </div>
          <div class="xc-modal-footer xc-flex-center">
            <div class="xc-btn-group">
              <div class="xc-btn xc-btn-default" @click="modalName = null">
                取消
              </div>
              <div class="xc-btn xc-btn-primary" @click="editGroup">确定</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 终端分组移动分组 -->
    <div class="xc-modal xc-modal-dialog" v-if="modalName == 'moveDeviceGroup'">
      <div class="xc-modal-mask" @click="modalName = null"></div>
      <div class="xc-modal-wrap xc-anim-scaleIn">
        <div class="xc-modal-content">
          <div class="xc-modal-header">
            <div class="xc-modal-title">移动分组</div>
            <div class="xc-modal-close" @click="modalName = null"></div>
          </div>
          <div class="xc-modal-body">
            <xc-tree
              :data.sync="moveGroups"
              @nodeClick="selectDeviceGroupName"
              label="name"
              linked
              :expand="0"
            ></xc-tree>
          </div>
          <div class="xc-modal-footer xc-flex-center">
            <div class="xc-btn-group">
              <div class="xc-btn xc-btn-default" @click="modalName = null">
                取消
              </div>
              <div class="xc-btn xc-btn-primary" @click="removeDeviceGroup">
                确定
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 导出上刊数据 -->
    <div class="xc-modal xc-modal-dialog" v-if="modalName == 'shangkanData'">
      <div class="xc-modal-mask" @click="modalName = null"></div>
      <div class="xc-modal-wrap xc-anim-scaleIn">
        <div class="xc-modal-content">
          <div class="xc-modal-header">
            <div class="xc-modal-title">导出上刊数据</div>
            <div class="xc-modal-close" @click="modalName = null"></div>
          </div>
          <div class="xc-modal-body xc-flex-center">
            <form class="xc-form" name="exportData" data-vv-scope="exportData">
              <xc-form-item
                required
                label="导出时间"
                class="xc-form-item-fixed"
                style="margin-bottom: 0"
              >
                <flat-pickr
                  v-validate="'required'"
                  data-vv-as="开始时间"
                  name="exportStartTime"
                  v-model="shangKanParams.startTime"
                  class="xc-input"
                  :class="{
                    'xc-input-error': errors.first(
                      'exportStartTime',
                      'exportData'
                    ),
                  }"
                  :config="exportSKConfig"
                  placeholder="请选择开始时间"
                ></flat-pickr>
                <span class="time-sign">至</span>
                <flat-pickr
                  v-validate="'required'"
                  data-vv-as="结束时间"
                  name="exportEndTime"
                  v-model="shangKanParams.endTime"
                  class="xc-input"
                  :class="{
                    'xc-input-error': errors.first(
                      'exportEndTime',
                      'exportData'
                    ),
                  }"
                  :config="exportSKConfig"
                  placeholder="请选择结束时间"
                ></flat-pickr>
              </xc-form-item>
              <!-- <div class="xc-form-inline">
                              <div class="xc-form-item-label"></div>
                              <ul class="error-tips">
                                  <li v-for="error in errors.all()" :key="error" style="flex:1;" class="xc-form-item-error-tips">{{error}}</li>
                              </ul>
                          </div> -->
            </form>
            <p class="xc-remark">注：只能选择将来一个月内的数据</p>
          </div>
          <div class="xc-modal-footer xc-flex-center">
            <div class="xc-btn-group">
              <div class="xc-btn xc-btn-default" @click="modalName = null">
                取消
              </div>
              <div class="xc-btn xc-btn-primary" @click="exportSKData">
                确定
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import deviceApi from "../api/device";
import mixin from "../xc-ui/mixins/list";

// vee-validate验证
import "@/libs/vee-validate";
import "@/utils/form-format";

// 日期控件
import "@/libs/flatpickr";
import { constants } from "crypto";
import myLayerImport from "@/libs/myLayer";
import { mapState, mapActions } from "vuex";
import moment from "moment";

// ip格式化
import "@/utils/ip-format";
import { filter } from "minimatch";

export default {
  name: "DeviceList",
  data() {
    return {
      id: 0,

      // 日期选择
      bootTime: "06:00:00",
      offTime: "23:00:00",
      nonWorkDayBootTime: "06:00:00",
      nonWorkDayOffTime: "23:00:00",
      // https://flatpickr.js.org/options/
      config: {
        // 时间格式
        dateFormat: "H:i:S",
        // 否启用时间选择
        enableTime: true,
        // 选择器中是否可以选择秒
        enableSeconds: true,
        // 是否显示日期
        noCalendar: true,
        time_24hr: true,
      },

      // 导出上刊数据,选择的时间配置
      exportSKConfig: {
        // 时间格式
        dateFormat: "Y-m-d H:i",
        // 否启用时间选择
        enableTime: true,
        // 选择器中是否可以选择秒
        enableSeconds: false,
        time_24hr: true,
        disable: [],
      },
      //合并input框后的选择的值
      changeItem: "MAC地址",
      searchInfo: "",

      showDate: true,

      deviceCodeList: "",

      // 列表key
      mix_listKey: "list",

      // 列表唯一字段
      mix_listId: "departmentId",

      list: [],

      // 默认查询参数
      mix_query: {
        groupName: "",
        deviceMac: "",
        deviceName: "",
        ip: "",
        deviceStatus: "",
        storeName: "",
        programDue: "",
      },

      // 移动分组选取值
      removeGroupValue: "",

      closeGroups: true,
      showOpenGroup: true,

      // 树形目录
      treeList: [],

      showTreeEdit: false, //右键菜单的显示
      showTreeSon: false, //右键添加儿子操作项的显示
      showTreeBrother: false, //右键添加兄弟菜单操作项的显示
      // 分组
      groupValue: [],

      // 增播素材
      materialValue: [],

      // 减播素材
      reduceMaterialValue: [],

      // 发布节目
      reduceMaterialValue: [],

      // 弹出窗
      modalName: null,

      modalData: {
        title: "我是标题",
      },

      radioValue: [
        {
          text: "启用",
          id: 1,
          active: true,
          value: 0,
        },
        {
          text: "关闭",
          id: 2,
          value: 1,
        },
      ],

      materialType: [
        {
          text: "图片",
          active: true,
        },
        {
          text: "视频",
        },
        {
          text: "网页",
        },
      ],

      editGroupTitll: "",
      deviceGroupName: "",
      deleteGroup: false,
      deviceGroupList: [],
      treeData: {},
      editGroupName: "",
      deviceSerial: {},
      allCount: 0,
      allGroupId: [],
      moveToGroupParentId: "",
      moveGroups: [],
      deviceInfo: {
        total: null,
        totalOffline: null,
        totalOnline: null,
      },
      // 导出查询参数
      obj: {
        groupName: "",
        deviceMac: "",
        deviceName: "",
        ip: "",
        deviceStatus: "",
        storeName: "",
        programDue: "",
        pageNum: 1,
        pageSize: 0,
      },
      // 导出上刊数据所查询的参数
      shangKanParams: {
        startTime: "",
        endTime: "",
      },
    };
  },

  mounted() {
    // 获取浏览器可视区域高度
    let clientHeight = `${document.documentElement.clientHeight}`; // document.body.clientWidth;
    if (this.$refs.devicePage && clientHeight) {
      this.$refs.devicePage.style.height = clientHeight - 120 + "px";
    }

    this.getTree();
    // window.onresize = function () {
    //   this.clientHeight = `${document.documentElement.clientHeight}`;
    // }
  },

  computed: {
    ...mapState(["globalConfig", "userModule"]), // 异步 页面需判断userModule是否获取到
    // 是否开启周么时间限制
    limitCheck() {
      if (
        this.globalConfig.bootTimeDiff &&
        this.globalConfig.bootTimeDiff.value == "true"
      ) {
        return true;
      } else {
        return false;
      }
    },
  },

  async created() {
    // 加载JS
    await myLayerImport();
    console.log(this.globalConfig, this.userModule);
  },
  filters: {
    getPlayDue(value) {
      if (value) {
        return "空刊";
      } else {
        return "有刊";
      }
    },
  },

  watch: {
    // // 如果 `clientHeight` 发生改变，这个函数就会运行
    // clientHeight: function () {
    //   this.changeFixed(this.clientHeight)
    // },
    modalName(newValue, oldValue) {
      if (newValue == null) {
        (this.deviceGroupId = ""), (this.moveToGroupParentId = "");
      }
    },
    //监测下拉选择框的值改变后，来变化这个值
    changeItem: function (value) {
      this.searchInfo = "";
      this.mix_query.ip = "";
      this.mix_query.deviceName = "";
      this.mix_query.deviceMac = "";
    },
    searchInfo: function (value) {
      if (this.changeItem == "MAC地址") {
        this.mix_query.deviceMac = value;
      } else if (this.changeItem == "终端名") {
        this.mix_query.deviceName = value;
      } else {
        this.mix_query.ip = value;
      }
    },
  },

  methods: {
    searchList() {
      this.mix_search();
      this.obj = {
        pageNum: 1,
        pageSize: 0,
        ...this.mix_query,
      };
    },
    //导出列表
    exportStore() {
      deviceApi
        .exportDeviceExcel({
          responseType: "blob",
          params: this.obj,
        })
        .then((v) => {
          console.log(v, "获取的导出数据");
          this.$message.success("导出成功");
          let url = window.URL.createObjectURL(new Blob([v]));
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", "终端列表.xlsx");

          document.body.appendChild(link);
          link.click();
        })
        .catch((res) => {
          console.log(res);
        });
    },

    // 验证是否又必填字段
    verifyRequired() {
      const scope = "exportData";
      this.$validator.validateAll(scope).then((validate) => {
        console.log(validate, "validate");
        if (validate) {
          this.exportSKData();
        }
      });
    },

    // 导出上刊数据
    exportSKData() {
      console.log(
        this.shangKanParams.startTime,
        "this.shangKanParams.startTime"
      );
      if (!this.shangKanParams.startTime)
        return this.$message.error("请选择开始时间");
      if (
        this.shangKanParams.startTime &&
        new Date().getTime() + 3600 * 1000 * 24 >=
          new Date(this.shangKanParams.startTime).getTime() + 3600 * 1000 * 24
      ) {
        return this.$message.error("开始时间不能小于当前时间");
      }
      if (!this.shangKanParams.endTime)
        return this.$message.error("请选择结束时间");
      if (
        new Date(this.shangKanParams.endTime).getTime() + 3600 * 1000 * 24 >=
        new Date(this.shangKanParams.startTime).getTime() +
          3600 * 1000 * 24 * 31
      ) {
        return this.$message.error("时间区间必须在将来的一个月内");
      }
      if (this.shangKanParams.startTime >= this.shangKanParams.endTime)
        return this.$message.error("开始时间不能大于结束时间");
      if (
        moment(this.shangKanParams.endTime).diff(
          moment(this.shangKanParams.startTime),
          "days",
          true
        ) > 31
      ) {
        return this.$message.error("时间差值不能大于31天");
      }
      this.$http
        .get("/device/exportDeviceProgramListExcel", {
          responseType: "blob",
          showLoading: "导出中...",
          params: {
            startTime: moment(this.shangKanParams.startTime).valueOf(),
            endTime: moment(this.shangKanParams.endTime).valueOf(),
            ...this.obj,
          },
        })
        .then((v) => {
          this.modalName = "";
          this.$message.success("导出成功");
          let url = window.URL.createObjectURL(new Blob([v]));
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", "上刊数据.xlsx");
          document.body.appendChild(link);
          link.click();
          // 释放掉blob对象
          window.URL.revokeObjectURL(url);
        });
    },

    // 动态获取高度
    // changeFixed(this.clientHeight){
    //   this.$refs.devicePage.style.height = clientHeight - 120 +'px';
    // },

    // 遍历树
    ergodicTree(data) {
      const treeList = {};
      /**
       * 把数组转换成一维对象
       */
      (function toObject(list) {
        list.map((item) => {
          item.deviceTotal = item.deviceCount;
          if (!item.id) {
            item.id = 1;
          }
          treeList[item.id] = item;

          if (item.children && item.children.length) {
            toObject(item.children);
          }
        });
      })(data);
      // 控制元素展开状态
      /*const setExpand = (item) => {
              if(item.id==pId){
                  item.expand=true;
                  pId=item.parentId;
                  if(pId){
                      let parent=treeList[item.parentId];
                      setExpand(parent);
                  }
              }else {
                  return;
              }
              }*/
      /**
       * 给所有父元素增加数量
       */
      const setParentTotal = (item, deviceCount) => {
        if (item.parentId) {
          const parent = treeList[item.parentId];
          const curDeviceCount = deviceCount || item.deviceCount;

          // console.log(item,item,item.name,'curDeviceCount',curDeviceCount)
          parent.deviceTotal += curDeviceCount;
          if (curDeviceCount) setParentTotal(parent, curDeviceCount);
        }
      };

      // 遍历一次对象
      for (const key in treeList) {
        if (treeList.hasOwnProperty(key)) {
          const item = treeList[key];
          setParentTotal(item);
        }
      }

      for (const key in treeList) {
        if (treeList.hasOwnProperty(key)) {
          const item = treeList[key];
          item.name += "(" + item.deviceTotal + ")";
        }
      }
    },

    // 获取树形分组
    getTree() {
      let that = this;
      deviceApi.getDeviceGroup().then((v) => {
        const tree = [...v.data];
        tree[0] = {
          ...tree[0],
          active: true,
        };
        that.treeList = tree;
        this.ergodicTree(tree);
      });
    },

    // 获取移动分组树形分组
    getGroupTree(tag) {
      deviceApi.getDeviceGroup().then((v) => {
        const deviceGroupList = v.data;
        deviceGroupList[0] = {
          ...deviceGroupList[0],
          active: false,
        };

        if (tag == "move") {
          this.moveGroups = deviceGroupList;
          this.$nextTick(() => {
            this.modalName = "moveDeviceGroup";
          });
        } else {
          this.deviceGroupList = deviceGroupList;
          this.$nextTick(() => {
            this.modalName = "moveGroup";
          });
        }
      });
    },

    // 编辑终端分组
    openEditGroup(tag) {
      if (tag == "move") {
        // 获取树形分组
        this.getGroupTree(tag);
      } else {
        this.modalName = "edit-group";
      }

      this.groupTag = tag;
      this.deleteGroup = false;

      if (tag == "add") {
        this.editGroupTitll = "添加分组";
        this.deviceGroupName = "";
      } else if (tag == "addChild") {
        this.editGroupTitll = "添加子分组";
        this.deviceGroupName = "";
      } else if (tag == "edit") {
        this.editGroupTitll = "编辑分组";
        this.deviceGroupName = this.treeData.name.replace(/\([^\)]*\)/g, "");
      } else if (tag == "delete") {
        this.editGroupTitll = "删除分组";
        this.deleteGroup = true;
        this.deviceGroupName = this.treeData.name;
      }

      this.showTreeEdit = false;
      this.showTreeSon = false;
      this.showTreeBrother = false;
    },

    // 终端组-编辑分组
    editGroup() {
      let that = this;
      let id = this.treeData.id;
      let parentId = this.treeData.parentId;
      let treeParentId = this.treeData.treeParentId;

      if (this.groupTag == "delete") {
        // 删除分组
        deviceApi.deleteDevicegroup({ deviceGroupId: id }).then((v) => {
          // 更新树形列表
          //  删除该元素
          let groupTree = this.$refs.groupTree;
          let index = groupTree.objTree[treeParentId].children.findIndex(
            function (item) {
              return item.id == id;
            }
          );
          groupTree.objTree[treeParentId].children.splice(index, 1);
          //  修改父级分组的终端数目
          let deviceCount = this.treeData.deviceCount;
          const setParentTotal = (item) => {
            if (item.parentId) {
              const parent = groupTree.objTree[item.treeParentId];
              parent.deviceTotal -= deviceCount;
              let i = parent.name.indexOf("(");
              let name = parent.name.substring(0, i);
              parent.name = name + "(" + parent.deviceTotal + ")";
              setParentTotal(parent);
            }
          };
          if (deviceCount) {
            setParentTotal(this.treeData);
          }
          // this.getTree();
          // 成功后关闭窗口
          that.$message.success(v.msg);
          that.modalName = null;
        });
      } else {
        // 验证器命名空间
        const scope = "form";
        // vee表单验证方法
        this.$validator
          .validateAll(scope)
          .then((validate) => {
            if (validate) {
              return this.$formFormat(document.treeAddGroup);
            } else {
              let error = this.errors.items[0].msg;
              this.$message.error(error);
            }
          })
          .then((formData) => {
            // 请求参数
            let groupName = formData.name;

            if (this.groupTag == "add") {
              // 添加分组请求
              deviceApi.addDevicegroup({ parentId, groupName }).then((v) => {
                // 更新树形列表
                this.getTree();

                // 成功后关闭窗口
                that.$message.success("添加成功");
                that.modalName = null;
              });
            } else if (this.groupTag == "addChild") {
              // 添加子分组请求
              deviceApi
                .addDevicegroup({ parentId: id, groupName })
                .then((v) => {
                  // 更新树形列表
                  this.getTree();

                  // 成功后关闭窗口
                  that.$message.success("添加成功");
                  that.modalName = null;
                });
            } else if (this.groupTag == "edit") {
              // 修改分组
              deviceApi
                .updateDevicegroup({
                  parentId,
                  groupName,
                  deviceGroupId: id,
                })
                .then((v) => {
                  // 更新树形列表
                  this.getTree();

                  // 成功后关闭窗口
                  that.$message.success("修改成功");
                  that.modalName = null;
                });
            }
          });
      }
    },

    // 移动终端树形分组
    removeDeviceGroup() {
      let that = this;
      let deviceGroupId = this.treeData.id;
      let parentId = this.moveToGroupParentId;
      if (parentId == 1) {
        parentId = "";
      }
      let treeArr = [];
      treeArr.push(this.treeData);
      let filtersEnd = this.filterChildeId(treeArr, parentId);
      if (filtersEnd) {
        this.$message.warning("父分组不能为自身及其子分组！");
        return;
      }
      let groupName = this.treeData.name.replace(/\([^\)]*\)/g, "");
      if (this.moveToGroupParentId) {
        deviceApi
          .updateDevicegroup({ parentId, groupName, deviceGroupId })
          .then((v) => {
            this.getTree();
            this.mix_query.groupId = "";
            this.initData();

            that.$message.success(v.msg);
            that.modalName = null;
          });
      } else {
        this.$message.warning("请选择分组");
      }
    },

    // 查询父元素id是否等于自身id或子节点id
    filterChildeId(data, filterId) {
      let that = this;
      for (let item of data) {
        if (item.id == filterId) {
          return true;
        } else {
          if (item.children.length > 0) {
            return that.filterChildeId(item.children, filterId);
          }
        }
      }
    },

    // 移动终端分组选择终端
    selectDeviceGroupName(data) {
      console.log("data123", data);
      if (data) {
        if (!data.id) {
          data.id = 1;
        }
        this.moveToGroupParentId = data.id;
      } else {
        this.moveToGroupParentId = "";
      }
    },

    // 关闭树形弹层
    closeTreeEdit() {
      this.showTreeEdit = false;
      this.showTreeSon = false;
      this.showTreeBrother = false;
    },

    // 打开导出上刊数据的弹框
    exportShangkan() {
      this.modalName = "shangkanData";
      this.shangKanParams.startTime = "";
      this.shangKanParams.endTime = "";
    },

    // 移动分组
    removeGroup() {
      let that = this;
      let deviceGroupId = this.deviceGroupId;
      if (this.deviceGroupId) {
        // 移动分组请求
        deviceApi
          .deviceGroupMove(this.deviceCodeList, deviceGroupId)
          .then((v) => {
            this.getTree();
            // this.selectFunc(this.treeData);
            this.mix_query.groupId = "";
            this.initData();
            // 成功后关闭窗口
            that.$message.success(v.msg);
            that.modalName = null;
          });
      } else {
        this.$message.warning("请选择分组");
      }
    },

    // 远程关机
    deviceShutdown() {
      let that = this;

      deviceApi.deviceShutdown(this.deviceCodeList).then((v) => {
        // this.mix_batchUpdate({
        //   deviceStatus: "离线"
        // });
        // 成功后关闭窗口
        that.$message.success("关机指令下发成功");
        that.modalName = null;
      });
    },

    // 重启终端
    restartDevice() {
      let that = this;

      deviceApi.deviceRestart(this.deviceCodeList).then((v) => {
        // that.mix_batchUpdate({
        //   deviceStatus: "在线"
        // });
        // 成功后关闭窗口
        that.$message.success("重启指令下发成功");
        that.modalName = null;
      });
    },

    // 音量设置
    volumeSetting() {
      let that = this;

      // 验证器命名空间
      const scope = "voice";

      // vee表单验证方法
      this.$validator
        .validateAll(scope)
        .then((validate) => {
          if (validate) {
            return this.$formFormat(document.voice);
          } else {
            let error = this.errors.items[0].msg;
            this.$message.error(error);
          }
        })
        .then((formData) => {
          if (isNaN(formData.voiceValue))
            return this.$message.error("请设置正确的音量值");
          if (formData.voiceValue < 0 || formData.voiceValue > 100)
            return this.$message.error("请设置0-100的数值");

          // 请求参数
          let deviceVolume = formData.voiceValue;

          // 移动分组请求
          deviceApi.setVolume(this.deviceCodeList, deviceVolume).then((v) => {
            that.$message.success("音量修改指令下发成功");
            that.modalName = null;
          });
        });
    },

    // 解绑终端
    unbundlingDevice() {
      let that = this;

      deviceApi.deviceUntie(this.deviceCodeList).then((v) => {
        // 更新终端列表
        this.selectFunc(this.treeData);

        // 成功后关闭窗口
        that.$message.success("解绑指令下发成功");
        that.modalName = null;
      });
    },

    // 定时开关机
    switchgear() {
      let that = this;
      let params;

      if (this.showDate) {
        if (
          parseInt(this.bootTime.substring(0, 2)) >
            parseInt(this.offTime.substring(0, 2)) ||
          parseInt(this.nonWorkDayBootTime.substring(0, 2)) >
            parseInt(this.nonWorkDayOffTime.substring(0, 2))
        ) {
          that.$message.warning("开机时间不能大于关机时间");
          return;
        }
        params = {
          deviceCodes: this.deviceCodeList,
          bootTime: this.bootTime,
          offTime: this.offTime,
          nonWorkDayBootTime: this.nonWorkDayBootTime,
          nonWorkDayOffTime: this.nonWorkDayOffTime,
        };
      } else {
        params = {
          deviceCodes: this.deviceCodeList,
          bootTime: "00:00:00",
          offTime: "00:00:00",
          nonWorkDayBootTime: "00:00:00",
          nonWorkDayOffTime: "00:00:00",
        };
      }

      deviceApi.setTimerShutDownOrStart({ ...params }).then((v) => {
        // 成功后关闭窗口
        that.$message.success("定时开关机指令下发成功");
        that.modalName = null;
      });
    },

    // 发布节目
    publishProgram() {
      const { mix_checkedList } = this;
      if (mix_checkedList.length > 0) {
        // 获取设备序列号
        let deviceCodes = [];
        for (let item of mix_checkedList) {
          deviceCodes.push(item.deviceCode);
        }

        let codes = deviceCodes.join(",");
        myLayer.open({
          type: 2,
          title: false,
          shadeClose: true,
          closeBtn: 0, //不显示关闭按钮
          area: ["65%", "550px"],
          content:
            this.$config.adminPath +
            "/device/:deviceId/publishProgram?deviceCodes=" +
            codes,
          success: function (layero, index) {},
        });
      } else {
        this.$message.warning("请选择数据");
      }
    },

    // 文件增播
    increasedPlay() {
      const { mix_checkedList } = this;
      if (mix_checkedList.length > 0) {
        if (mix_checkedList.length > 1) {
          this.$message.warning("只能选择一个终端");
          return;
        }

        // 获取设备序列号
        let deviceCode = mix_checkedList[0].deviceCode;
        // for (let item of mix_checkedList) {
        //   deviceCodes.push(item.deviceCode)
        // }
        // let codes = deviceCodes.join(',')

        // 获取设备类型
        let deviceType = mix_checkedList[0].deviceType;

        // 获取设备分辨率
        let deviceResolution = mix_checkedList[0].resolvingPower;

        myLayer.open({
          type: 2,
          title: false,
          shadeClose: true,
          closeBtn: 0, //不显示关闭按钮
          area: ["1000px", "550px"],
          content:
            this.$config.adminPath +
            "/device/:deviceId/increasedPlay?deviceCode=" +
            deviceCode +
            "&deviceType=" +
            deviceType +
            "&deviceResolution=" +
            deviceResolution,
          success: function (layero, index) {},
        });
      } else {
        this.$message.warning("请选择数据");
      }
    },

    // 文件减播
    reducePlay() {
      const { mix_checkedList } = this;
      if (mix_checkedList.length > 0) {
        if (mix_checkedList.length > 1) {
          this.$message.warning("只能选择一个终端");
          return;
        }

        // 获取设备序列号
        let deviceCode = mix_checkedList[0].deviceCode;

        myLayer.open({
          type: 2,
          title: false,
          shadeClose: true,
          closeBtn: 0, //不显示关闭按钮
          area: ["981px", "550px"],
          content:
            this.$config.adminPath +
            "/device/:deviceId/reducePlay?deviceCode=" +
            deviceCode,
          success: function (layero, index) {},
        });
      } else {
        this.$message.warning("请选择数据");
      }
    },

    // 操作单条数据
    action(...args) {
      const [action, item, index] = args;
      const e = args[args.length - 1];
      // 获取设备序列号
      let deviceCode = item.deviceCode;
      switch (action) {
        // 查看终端详情
        case "getDeviceDetail":
          // 全局存储
          sessionStorage.setItem("deviceInfo", JSON.stringify(item));
          //   this.$router.push(
          //     `${this.$config.adminPath}/device/${item.deviceCode}/detail`
          //   );
          //   this.layer({
          //     area: ["90%", "90vh"],
          //     content: `${this.$config.adminPath}/device/${item.deviceCode}/detail`
          //   });
          layer.openSubpage(
            `${this.$config.adminPath}/device/${item.deviceCode}/detail`
          );
          break;
        // 查看播放列表
        case "goListDetail":
          // 获取设备序列号
          sessionStorage.setItem("deviceDetail", JSON.stringify(item));
          layer.openSubpage(
            `${this.$config.adminPath}/device/${item.deviceCode}/play`
          );
          break;
        default:
          break;
      }
    },

    // 批量操作
    batchAction(...args) {
      const action = args[0];
      const e = args[args.length - 1];

      // 批量操作的数据
      const { mix_checkedList } = this;

      switch (action) {
        // 批量删除
        case "delete":
          // 后台删除成功后调用
          this.mix_batchDelete();
          break;
        // 批量修改
        case "update":
          // 后台修改成功后调用
          this.mix_batchUpdate({ title: "一二三" });
          break;
        // 批量移动分组
        case "moveGroup":
          this.removeGroup(mix_checkedList);
          break;
        // 批量远程关机
        case "remoteShutdown":
          this.deviceShutdown();
          break;
        // 批量重启终端
        case "restartDevice":
          this.restartDevice();
          break;
        // 批量音量设置
        case "volumeSetting":
          this.volumeSetting();
          break;
        // 批量解绑终端
        case "unbundlingDevice":
          this.unbundlingDevice();
          break;
        // 批量定时开关机设置
        case "switchgear":
          this.switchgear();
          break;
        default:
          break;
      }
    },

    // 初始化数据
    initData(v) {
      // 默认搜索的数据
      const search = {
        pageNum: 1,
        pageSize: 0,
        ...this.mix_query,
      };

      deviceApi.getDeviceList(search).then((v) => {
        let ret = v;
        this.list = this.mix_format(ret.data.list);
        this.deviceInfo.total = ret.data.total;
        this.deviceInfo.totalOffline = ret.data.totalOffline;
        this.deviceInfo.totalOnline = ret.data.totalOnline;
        // this.mix_total = ret.data.total;
        // this.mix_page = ret.data.pageNum;
        // this.mix_pageSize = ret.data.pageSize;
      });
    },

    // 遍历groupId方法
    getGroupId(data) {
      for (let item of data) {
        this.allGroupId.push(item.id);
        if (item.children && item.children.length > 0) {
          this.getGroupId(item.children);
        }
      }
    },

    // 树形点击文字的回调
    selectFunc: function (data) {
      this.treeData = data;
      let query, groupName;
      this.allGroupId = [];
      if (data) {
        if (data.id == 1) {
          groupName = "";
          query = {
            groupId: "",
          };
        } else {
          groupName = data.name;
          let dataArr = [];
          dataArr.push(data);
          this.getGroupId(dataArr);
          console.log("this.allGroupId", this.allGroupId.join(","));

          query = {
            groupId: this.allGroupId.join(","),
          };
        }
      } else {
        groupName = "";
        query = {
          groupId: "",
        };
      }

      this.mix_query.groupId = query.groupId;

      // deviceApi.getDeviceList(query).then(v => {
      //   let ret = v;

      //   this.list = this.mix_format(ret.data.list);
      //   this.mix_total = ret.data.total;
      //   this.mix_page = ret.data.pageNum;
      //   this.mix_pageSize = ret.data.pageSize;
      // });
      this.initData();
    },

    // 移动分组选择终端
    selectGroupName(data) {
      console.log("data", data);
      if (data) {
        if (!data.id) {
          data.id = 1;
        }
        if (data.id == 1) {
          this.deviceGroupId = "";
        } else {
          this.deviceGroupId = data.id;
        }
      } else {
        this.deviceGroupId = "";
      }
    },

    // 树形目录右键点击的回调
    rightClick: function (data) {
      console.log("树形目录右键点击的回调", data);
      this.treeData = data.data;

      if (this.treeData.id == null) {
        // 点击全部分组，且该分组id为null
        this.showTreeEdit = false;
        this.showTreeSon = false;
        this.showTreeBrother = false;
      } else if (this.treeData.id == 1) {
        // 点击全部分组且该分组id为1
        this.showTreeEdit = false;
        this.showTreeSon = true;
        this.showTreeBrother = false;
      } else {
        // 点击其他分组
        if (this.treeData.level == 1) {
          var treeParent =
            this.$refs.groupTree.objTree[this.treeData.treeParentId];

          if (treeParent.id == null) {
            this.showTreeEdit = true;
            this.showTreeSon = true;
            this.showTreeBrother = false;
          } else {
            this.showTreeEdit = true;
            this.showTreeSon = true;
            this.showTreeBrother = true;
          }
        } else {
          this.showTreeEdit = true;
          this.showTreeSon = true;
          this.showTreeBrother = true;
        }
      }

      let x = data.event.clientX + 10;
      let y = data.event.clientY + 10;
      let treeEdit = this.$refs.treeEdit;
      this.$nextTick(function () {
        var H = document.documentElement.clientHeight;
        var h = treeEdit.clientHeight;
        if (y > H - h) {
          y = H - h - 10;
        }
        treeEdit.style.left = x + "px";
        treeEdit.style.top = y + "px";
      });
    },

    // 打开弹窗
    openMode(mode) {
      // 批量操作的数据
      const { mix_checkedList } = this;
      if (mix_checkedList.length > 0) {
        if (mode == "moveGroup") {
          //如果是移动分组
          this.getGroupTree();
        } else {
          this.modalName = mode;
        }
        // 获取设备序列号
        let deviceCodes = [];
        let deviceSerialNum = [];
        let deviceSerialNumLen = mix_checkedList.length;

        for (let item of mix_checkedList) {
          deviceCodes.push(item.deviceCode);
        }

        if (deviceSerialNumLen > 3) {
          for (let i = 0; i < 3; i++) {
            deviceSerialNum.push(mix_checkedList[i].deviceSerialNum);
          }
          this.deviceSerial.deviceSerialNumList =
            deviceSerialNum.join("，") + "等";
        } else {
          for (let item of mix_checkedList) {
            deviceSerialNum.push(item.deviceSerialNum);
          }
          this.deviceSerial.deviceSerialNumList = deviceSerialNum.join("，");
        }

        for (let item of mix_checkedList) {
          deviceSerialNum.push(item.deviceSerialNum);
        }

        this.deviceCodeList = deviceCodes.join(",");
        this.deviceSerial.deviceSerialNumLen = deviceSerialNumLen;

        if (mode == "switchgear") {
          // 获取设备名称
          let deviceNames = [];
          for (let item of mix_checkedList) {
            deviceNames.push(item.deviceName);
          }
          this.deviceNameList = deviceNames.join(",");
        }
      } else {
        this.$message.warning("请选择数据");
      }
    },

    // 弹出框
    submitModal() {},

    // 单选按钮回调
    radioSelectFun: function (value) {
      if (value == 0) {
        this.showDate = true;
      } else {
        this.showDate = false;
      }
    },

    // 收起组名
    closeGroup() {
      this.closeGroups = true;
    },

    // 展开组名
    openGroup() {
      this.closeGroups = false;
    },

    // 选择组名
    selectGroup(e) {
      let { index } = e.currentTarget.dataset;
      const groupValue = [...this.groupValue];

      for (let item of groupValue) {
        item.checked = false;
      }

      groupValue[index].checked = true;
      this.groupValue = groupValue;
    },

    // 增播选择素材
    selectMaterial(e) {
      let { index } = e.currentTarget.dataset;
      const materialValue = [...this.materialValue];
      materialValue[index].checked = !materialValue[index].checked;
      // for (let item of materialValue) {
      //   if (item.checked) {
      //     // 获取值
      //   }
      // }
      this.materialValue = materialValue;
    },

    // 减播选择节目素材
    selectProgramMaterial(e) {
      let { index } = e.currentTarget.dataset;
      const reduceMaterialValue = [...this.reduceMaterialValue];
      reduceMaterialValue[index].checked = !reduceMaterialValue[index].checked;
      // for (let item of reduceMaterialValue) {
      //   if (item.checked) {
      //     // 获取值
      //   }
      // }
      this.reduceMaterialValue = reduceMaterialValue;
    },

    layer(options) {
      layer.open({
        type: 2,
        title: false,
        closeBtn: 0,
        shadeClose: true,
        area: ["672px", "379px"],
        ...options,
      });
    },
  },

  mixins: [mixin],
};
</script>

<style scoped lang="scss">
.xc-remark {
  text-align: left;
  width: 100%;
}
.xc-page {
  height: 100%;
  flex: 1;
}

.table-content {
  margin: 0px 20px;
}

.xc-modal-dialog .xc-modal-body {
  max-height: 272px;
}

.xc-device-group-head {
  font-size: 14px;
  color: #6e7a90;
  margin-bottom: 16px;
}

.xc-device-group-head span {
  font-size: 18px;
}

.xc-device-group {
  display: flex;
}

.device-tree-wrap {
  position: relative;
  overflow: auto;
  height: calc(100% - 47px);
  height: -webkit-calc(100% - 47px);
  padding: 20px 20px 20px 10px;
  box-sizing: border-box;
  display: flex;
}

.tree {
  flex: 1;
  height: 100%;
  padding-right: 10px;
  box-sizing: border-box;
}

.xc-device-group-title {
  width: 40px;
  line-height: 24px;
}

.xc-device-group-main {
  flex: 1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  overflow: hidden;
}

.xc-device-group-main-close {
  flex: 1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  overflow: hidden;
  height: 38px;
  position: relative;
  padding-right: 84px;
  box-sizing: border-box;
}

.xc-device-group-close,
.xc-device-group-open {
  display: flex;
  align-items: center;
  color: #507dde;
  margin-bottom: 14px;
  cursor: pointer;
}

.xc-device-group-close span,
.xc-device-group-open span {
  margin-right: 2px;
}

.xc-device-group-close span {
  margin-left: 5px;
}

.xc-device-group-close img,
.xc-device-group-open img {
  width: 9px;
  height: 6px;
}

.xc-device-group-open img {
  transform: rotate(180deg);
}

.xc-device-group-open {
  position: absolute;
  top: 0;
  right: 40px;
}

.xc-device-group-item {
  padding: 5px 12px;
  line-height: 14px;
  font-size: 14px;
  color: #6e7a90;
  margin-bottom: 14px;
  cursor: pointer;
}

.xc-device-group-item:hover {
  color: rgba(80, 125, 222, 0.5);
}

.xc-device-group-item-checked {
  padding: 5px 12px;
  line-height: 14px;
  font-size: 14px;
  color: #fff;
  background: rgba(80, 125, 222, 0.5);
  border-radius: 8px;
  margin-bottom: 14px;
  cursor: pointer;
}

.xc-device-material {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.xc-device-material-item,
.xc-device-material-item-checked,
.xc-device-material-program,
.xc-device-material-program-checked {
  width: 222px;
  height: 127px;
  border-radius: 4px;
  background: #eee;
  margin-right: 16px;
  margin-bottom: 16px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-sizing: border-box;
}

.xc-device-material-program,
.xc-device-material-program-checked {
  margin-right: 0;
}

.xc-device-material-item::before,
.xc-device-material-item-checked::before,
.xc-device-material-program::before,
.xc-device-material-program-checked::before {
  content: "";
  width: 16px;
  height: 16px;
  background-color: #ffffff;
  border-radius: 4px;
  border: solid 1px #cfd5e0;
  position: absolute;
  top: 9px;
  right: 9px;
}

.xc-device-material-item-checked::before,
.xc-device-material-program-checked::before {
  background-color: #507dde;
}

.xc-device-material-item-checked::after,
.xc-device-material-program-checked::after {
  content: "";
  width: 6px;
  height: 10px;
  border-color: #fff;
  border-style: solid;
  border-width: 0 2px 2px 0;
  border-radius: 2px;
  transform: rotate(45deg);
  position: absolute;
  top: 10px;
  right: 14px;
  z-index: 11;
}

.xc-device-material-name {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 21px;
  background-color: rgba(0, 0, 0, 0.65);
  line-height: 20px;
  padding: 0 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: white;
  font-size: 12px;
}

.xc-device-material-item img {
  width: 222px;
  height: 127px;
}

.xc-device-material-item-checked img {
  width: 222px;
  height: 127px;
}

.xc-device-material-item:nth-child(4n),
.xc-device-material-item-checked:nth-child(4n) {
  margin-right: 0;
}

.xc-device-row-item {
  display: flex;
  align-items: center;
}

.xc-device-row-title {
  margin-right: 8px;
}

.xc-device-input {
  flex: 1;
  width: 220px;
  height: 32px;
  line-height: 32px;
  padding: 0 10px;
  background-color: #ffffff;
  border-radius: 6px;
  border: solid 1px #cfd5e0;
  color: #808b9e;
  font-size: inherit;
  margin-right: 14px;
}

::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #cfd5e0;
}
:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #cfd5e0;
}
::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #cfd5e0;
}
:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #cfd5e0;
}

.xc-device-tipText {
  font-size: 18px;
  color: #6e7a90;
}

.xc-tree-edit {
  position: fixed;
  background: #fff;
  border: solid 1px #eee;
  border-radius: 8px;
  padding: 10px 16px;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.05);
  z-index: 2;
}

.xc-tree-edit ul li {
  line-height: 30px;
  cursor: pointer;
}

.xc-tree-edit ul li:hover {
  color: #507dde;
}

.device-group {
  width: 300px;
  // margin-right: 16px;
}

.xc-card-content {
  padding: 0 0;
  margin: 24px 20px;
}

.padding-bottom {
  padding-bottom: 24px;
}

.xc-home-container .xc-home-content .xc-page-main > .xc-row:last-child {
  padding-bottom: 0;
}

.search-line {
  list-style-type: none;
}

.search-line .search-list {
  float: left;
  margin: 0px 25px 25px 0px;
}

.null-box {
  clear: both;
}

.new-style {
  justify-content: space-between;
  align-items: center;
}

.device-info {
  display: flex;
  // margin-bottom:24px;
  .device-info-item {
    margin-right: 20px;
    font-size: 14px;
  }
}

.search-wrap {
  display: flex;
}
.change-wrap {
  position: relative;
  left: 3px;
  width: 100px;
  padding-left: 5px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  z-index: 1;
}
.add-bottom {
  margin-bottom: 24px;
  .xc-btn {
    min-width: 50px;
  }
}

// 时间插件的选择分隔样式
.time-sign {
  padding: 0px 10px;
}

// 粗错误信息的展示
.error-tips {
  display: flex;
  flex: 1;
  li:last-child {
    margin-left: 34px;
  }
}
</style>
